import { createContext, useContext } from "react";
import { ISettingContext } from "../@types";

export const SettingContext = createContext<ISettingContext>({} as ISettingContext);

export const useSettingContext = () => useContext(SettingContext);
